import { render, staticRenderFns } from "./PolicyDetailIntro.vue?vue&type=template&id=f237708e"
import script from "./PolicyDetailIntro.vue?vue&type=script&lang=js"
export * from "./PolicyDetailIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports